/**
 * R1AS faucet easter egg stations — docs/R1AS_FAUCET_EASTER_EGG.md
 * SoftPlan mesh names + annotation-driven stations (docs/SIM_LAB_ANNOTATE.md).
 */

/** @typedef {'sink' | 'shower'} FaucetType */

/**
 * @type {Array<{
 *   id: string,
 *   type: FaucetType,
 *   meshNames?: string[],
 *   spoutMesh?: string,
 *   useAnnotations?: boolean,
 *   spoutNudge?: [number, number, number],
 * }>}
 */
export const R1AS_FAUCETS = [
  {
    id: 'shower-west',
    type: 'shower',
    // SoftPlan valve/head are tiny + behind glass; prefer annotate pins + proxies
    useAnnotations: true,
    meshNames: ['floor_0_210', 'floor_0_211'],
    spoutMesh: 'floor_0_211',
    hitRadius: 0.18,
  },
  {
    // Bath vanity — annotate hit for clicks; mesh spout for stream tip
    id: 'sink-vanity',
    type: 'sink',
    useAnnotations: true,
    meshNames: [],
    spoutMesh: 'floor_0_212',
  },
  {
    id: 'sink-south',
    type: 'sink',
    meshNames: ['floor_0_212', 'floor_0_65', 'floor_0_29', 'floor_0_209'],
    spoutMesh: 'floor_0_212',
  },
  {
    id: 'sink-east',
    type: 'sink',
    meshNames: ['floor_0_213', 'floor_0_66', 'floor_0_192'],
    spoutMesh: 'floor_0_213',
  },
  {
    id: 'sink-living',
    type: 'sink',
    meshNames: ['floor_0_28', 'floor_0_95'],
    spoutMesh: 'floor_0_28',
  },
];

/** @type {Map<string, typeof R1AS_FAUCETS[number]>} */
export const R1AS_FAUCET_BY_MESH = (() => {
  const map = new Map();
  R1AS_FAUCETS.forEach((station) => {
    (station.meshNames || []).forEach((name) => map.set(name, station));
  });
  return map;
})();

export const R1AS_FAUCET_STATION_IDS = R1AS_FAUCETS.map((s) => s.id);

export function isR1asFaucetMesh(name = '') {
  return R1AS_FAUCET_BY_MESH.has(name);
}
